import { Map, fromJS } from 'immutable'
import {
  SET_SPEAKERLIST_PROCESSING,
  SET_SPEAKERLIST_DATA,
  SET_SPEAKERLIST_ERROR,
  SET_EVENTLIST_PROCESSING,
  SET_EVENTLIST_DATA,
  SET_EVENTLIST_ERROR,
  SET_EVENTDETAILS_PROCESSING,
  SET_EVENTDETAILS_DATA,
  SET_EVENTDETAILS_ERROR,
  SET_UPDATE_EVENTDETAILS_SUCCESS,
  SET_UPDATE_EVENTDETAILS_PROCESSING,
  SET_UPDATE_EVENTDETAILS_ERROR,
  CLEAR_UPDATE_EVENTDETAILS_ERROR,
  SET_CREATE_EVENT_SUCCESS,
  SET_CREATE_EVENT_PROCESSING,
  SET_CREATE_EVENT_ERROR,
  SET_UPDATE_EVENT_TRACK_PROCESSING,
  SET_UPDATE_EVENT_TRACK_SUCCESS,
  SET_UPDATE_EVENT_TRACK_ERROR,
  SET_EVENT_TRACKS_PROCESSING,
  SET_EVENT_TRACKS_DATA,
  SET_EVENT_TRACKS_ERROR,
  SET_EVENT_TRANSLATION_PROCESSING,
  SET_EVENT_TRANSLATION_DATA,
  SET_EVENT_TRANSLATION_ERROR,
  SET_UPDATE_EVENT_TRANSLATION_SUCCESS,
  SET_UPDATE_EVENT_TRANSLATION_PROCESSING,
  SET_UPDATE_EVENT_TRANSLATION_ERROR,
  SET_DELETE_EVENT_TRANSLATION_SUCCESS,
  SET_DELETE_EVENT_TRANSLATION_PROCESSING,
  SET_DELETE_EVENT_TRANSLATION_ERROR,
  SET_DELETE_SPOTLIGHT_TRANSLATION_SUCCESS,
  SET_DELETE_SPOTLIGHT_TRANSLATION_PROCESSING,
  SET_DELETE_SPOTLIGHT_TRANSLATION_ERROR,
  SET_CREATE_EVENT_TRACK_PROCESSING,
  SET_CREATE_EVENT_TRACK_SUCCESS,
  SET_CREATE_EVENT_TRACK_ERROR,
  SET_TRACK_DATA_PROCESSING,
  SET_TRACK_DATA,
  SET_TRACK_DATA_ERROR,
  SET_CHAT_BLOCKED_USERS_LIST_PROCESSING,
  SET_CHAT_BLOCKED_USERS_LIST,
  SET_CHAT_BLOCKED_USERS_LIST_ERROR,
  SET_EVENT_SCHEDULE_DATA,
  SET_EVENT_SCHEDULE_DATA_ERROR,
  SET_EVENT_SCHEDULE_DATA_PROCESSING,
  SET_LA_SPOTLIGHT_DATA,
  SET_LA_SPOTLIGHT_PROCESSING,
  SET_LA_SPOTLIGHT_ERROR,
  UPDATE_LA_SPOTLIGHT,
  SET_UPDATE_LA_SPOTLIGHT_SUCCESS,
  SET_UPDATE_LA_SPOTLIGHT_PROCESSING,
  SET_UPDATE_LA_SPOTLIGHT_ERROR,
  SET_CREATE_SESSION_PROCESSING,
  SET_CREATE_SESSION_SUCCESS,
  SET_CREATE_SESSION_ERROR,
  SET_UPDATE_SESSION_PROCESSING,
  SET_UPDATE_SESSION_SUCCESS,
  SET_UPDATE_SESSION_ERROR,
  SET_UPDATE_SESSION_TRANSLATION_PROCESSING,
  SET_UPDATE_SESSION_TRANSLATION_SUCCESS,
  SET_UPDATE_SESSION_TRANSLATION_ERROR,
  SET_CREATE_SPEAKER_PROCESSING,
  SET_CREATE_SPEAKER_SUCCESS,
  SET_CREATE_SPEAKER_ERROR,
  SET_UPDATE_SPEAKER_PROCESSING,
  SET_UPDATE_SPEAKER_SUCCESS,
  SET_UPDATE_SPEAKER_ERROR,
  SET_SPEAKER_PROCESSING,
  SET_SPEAKER_DATA,
  SET_SPEAKER_ERROR,
  SET_UPDATE_SPEAKER_BIO_PROCESSING,
  SET_UPDATE_SPEAKER_BIO_SUCCESS,
  SET_UPDATE_SPEAKER_BIO_ERROR,
  CLEAR_UPDATE_SPEAKER_BIO_ERROR,
  SET_EVENT_CHAT_INFO_DATA_PROCESSING,
  SET_EVENT_CHAT_INFO_DATA,
  SET_EVENT_CHAT_INFO_DATA_ERROR,
  SET_EVENT_CHAT_INFO_DATA_SUCCESS,
  SET_MEDIALIVE_CHANNEL_INFO_DATA_PROCESSING,
  SET_MEDIALIVE_CHANNEL_INFO_DATA_ERROR,
  SET_MEDIALIVE_CHANNEL_INFO_DATA,
  CLEAR_MEDIALIVE_CHANNEL_INFO,
  SET_CREATE_EVENT_CHAT_ERROR,
  SET_CREATE_EVENT_CHAT_PROCESSING,
  SET_CREATE_EVENT_CHAT_SUCCESS,
  SET_STREAM_START_PROCESSING,
  SET_STREAM_START_ERROR,
  SET_STREAM_START_SUCCESS,
  SET_STREAM_STOP_PROCESSING,
  SET_STREAM_STOP_ERROR,
  SET_STREAM_STOP_SUCCESS,
  CLEAR_MEDIALIVE_METRICS_DATA,
  SET_MEDIALIVE_METRICS,
  SET_MEDIALIVE_METRICS_ERROR,
  SET_MEDIALIVE_METRICS_PROCESSING,
  DELETE_SESSION_ERROR,
  DELETE_SESSION_PROCESSING,
  DELETE_SESSION_SUCCESS,
  DELETE_EVENT_ERROR,
  DELETE_EVENT_PROCESSING,
  DELETE_EVENT_SUCCESS,
  CLEAR_EVENT_CHAT_INFO,
  SET_USER_EMAIL,
  SET_USER_EMAIL_ERROR,
  SET_USER_EMAIL_PROCESSING,
  SET_UIDS_FROM_YOUBORA,
  GET_UIDS_FROM_YOUBORA_ERROR,
  GET_UIDS_FROM_YOUBORA_PROCESSING,
  CLEAR_UIDS_FROM_YOUBORA,
} from './actions'

export const initialState = Map()

const SPEAKERLIST_KEY = 'speakerList'
const UPDATE_EVENT_DETAILS_KEY = 'updateEventDetails'
const UPDATE_EVENT_TRACK_KEY = 'updateEventTrack'
const EVENT_DETAILS_KEY = 'eventDetails'
const EVENT_TRACKS_KEY = 'tracks'
const TRACK_KEY = 'track'
const CREATE_EVENT_KEY = 'createEvent'
const CREATE_EVENT_TRACK_KEY = 'createTrack'
const EVENT_LIST_KEY = 'eventList'
const EVENT_TRANSLATION_KEY = 'eventTranslation'
const UPDATE_EVENT_TRANSLATION_KEY = 'updateEventTranslation'
const DELETE_EVENT_TRANSLATION_KEY = 'deleteEventTranslation'
const DELETE_SPOTLIGHT_TRANSLATION_KEY = 'deleteSpotlightTranslation'
const CHAT_BLOCKED_USERS_KEY = 'chatBlockedUsers'
const EVENT_SCHEDULE_KEY = 'schedule'
const EVENT_SPOTLIGHT_KEY = 'laSpotlight'
const CREATE_SESSION_KEY = 'createSession'
const UPDATE_SESSION_KEY = 'updateSession'
const UPDATE_SESSION_TRANSLATION_KEY = 'updateSessionTranslation'
const CREATE_SPEAKER_KEY = 'createSpeaker'
const UPDATE_SPEAKER_KEY = 'updateSpeaker'
const SPEAKER_KEY = 'speaker'
const UPDATE_SPEAKER_BIO_KEY = 'updateSpeakerBio'
const CHAT_INFO_KEY = 'chatInfo'
const MEDIALIVE_KEY = 'mediaLive'
const START_STREAM_KEY = 'startStream'
const STOP_STREAM_KEY = 'stopStream'
const MEDIALIVE_METRICS_KEY = 'mediaLiveMetrics'
const DELETE_SESSION_KEY = 'deleteSession'
const DELETE_EVENT_KEY = 'deleteEvent'
const USER_EMAIL_KEY = 'userEmail'
const YOUBORA_UIDS_KEY = 'youboraUids'

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_UPDATE_EVENTDETAILS_PROCESSING:
      return state
        .setIn([UPDATE_EVENT_DETAILS_KEY, payload.eventId, 'processing'], payload.processing)
        .setIn([UPDATE_EVENT_DETAILS_KEY, 'processing'], payload.processing)
        .deleteIn([UPDATE_EVENT_DETAILS_KEY, payload.eventId, 'error'])
        .deleteIn([UPDATE_EVENT_DETAILS_KEY, 'error'])
        .deleteIn([UPDATE_EVENT_DETAILS_KEY, payload.eventId, 'success'])
        .deleteIn([UPDATE_EVENT_DETAILS_KEY, 'success'])
    case SET_UPDATE_EVENTDETAILS_SUCCESS:
      return state
        .setIn([UPDATE_EVENT_DETAILS_KEY, payload.eventId, 'success'], true)
        .setIn([UPDATE_EVENT_DETAILS_KEY, payload.eventId, 'processing'], false)
        .setIn([UPDATE_EVENT_DETAILS_KEY, 'success'], true)
        .deleteIn([UPDATE_EVENT_DETAILS_KEY, 'processing'])
    case SET_UPDATE_EVENTDETAILS_ERROR:
      return state
        .setIn([UPDATE_EVENT_DETAILS_KEY, payload.eventId, 'error'], payload.error)
        .setIn([UPDATE_EVENT_DETAILS_KEY, payload.eventId, 'processing'], false)
        .setIn([UPDATE_EVENT_DETAILS_KEY, 'error'], payload.error)
        .deleteIn([UPDATE_EVENT_DETAILS_KEY, 'processing'])
    case CLEAR_UPDATE_EVENTDETAILS_ERROR:
      return state
        .deleteIn([UPDATE_EVENT_DETAILS_KEY, payload.eventId, 'error'])
        .deleteIn([UPDATE_EVENT_DETAILS_KEY, 'error'])
    case SET_UPDATE_EVENT_TRACK_PROCESSING:
      return state
        .deleteIn([UPDATE_EVENT_TRACK_KEY, payload.trackId, 'success'])
        .setIn([UPDATE_EVENT_TRACK_KEY, payload.trackId, 'processing'], payload.processing)
    case SET_UPDATE_EVENT_TRACK_SUCCESS:
      return state
        .setIn([UPDATE_EVENT_TRACK_KEY, payload.trackId, 'success'], true)
        .setIn([UPDATE_EVENT_TRACK_KEY, payload.trackId, 'processing'], false)
    case SET_UPDATE_EVENT_TRACK_ERROR:
      return state
        .setIn([UPDATE_EVENT_TRACK_KEY, payload.trackId, 'error'], payload.error)
        .setIn([UPDATE_EVENT_TRACK_KEY, payload.trackId, 'processing'], false)
    case SET_CREATE_EVENT_PROCESSING:
      return state.setIn([CREATE_EVENT_KEY, 'processing'], payload.processing)
    case SET_CREATE_EVENT_SUCCESS:
      return state
        .setIn([CREATE_EVENT_KEY, 'success'], true)
        .setIn([CREATE_EVENT_KEY, 'processing'], false)
        .setIn([CREATE_EVENT_KEY, 'eventData'], fromJS(payload.eventData || {}))
    case SET_CREATE_EVENT_ERROR:
      return state
        .setIn([CREATE_EVENT_KEY, 'error'], payload.error)
        .setIn([CREATE_EVENT_KEY, 'processing'], false)
    case SET_CREATE_EVENT_TRACK_PROCESSING:
      return state.setIn([CREATE_EVENT_TRACK_KEY, 'processing'], payload.processing)
    case SET_CREATE_EVENT_TRACK_SUCCESS:
      return state
        .setIn([CREATE_EVENT_TRACK_KEY, 'success'], true)
        .setIn([CREATE_EVENT_TRACK_KEY, 'processing'], false)
    case SET_CREATE_EVENT_TRACK_ERROR:
      return state
        .setIn([CREATE_EVENT_TRACK_KEY, 'error'], payload.error)
        .setIn([CREATE_EVENT_TRACK_KEY, 'processing'], false)
    case SET_SPEAKERLIST_PROCESSING:
      return state.setIn([SPEAKERLIST_KEY, 'processing'], payload.processing)
    case SET_SPEAKERLIST_DATA:
      return state
        .setIn([SPEAKERLIST_KEY, 'data'], fromJS(payload.data))
        .setIn([SPEAKERLIST_KEY, 'processing'], false)
    case SET_SPEAKERLIST_ERROR:
      return state
        .setIn([SPEAKERLIST_KEY, 'error'], payload.error)
        .setIn([SPEAKERLIST_KEY, 'processing'], false)
    case SET_EVENTLIST_PROCESSING:
      return state
        .setIn([EVENT_LIST_KEY, 'processing'], payload.processing)
        .deleteIn([EVENT_LIST_KEY, 'success'])
        .deleteIn([EVENT_LIST_KEY, 'error'])
    case SET_EVENTLIST_DATA:
      return state
        .setIn([EVENT_LIST_KEY, 'data'], fromJS(payload.data))
        .deleteIn([EVENT_LIST_KEY, 'processing'])
        .setIn([EVENT_LIST_KEY, 'success'], true)
    case SET_EVENTLIST_ERROR:
      return state
        .setIn([EVENT_LIST_KEY, 'error'], payload.error)
        .deleteIn([EVENT_LIST_KEY, 'processing'])
        .deleteIn([EVENT_LIST_KEY, 'success'])
    case SET_EVENTDETAILS_PROCESSING:
      return state.setIn([EVENT_DETAILS_KEY, 'processing'], payload.processing)
    case SET_EVENTDETAILS_DATA:
      return state
        .setIn([EVENT_DETAILS_KEY, 'data'], fromJS(payload.data))
        .setIn([EVENT_DETAILS_KEY, 'processing'], false)
    case SET_EVENTDETAILS_ERROR:
      return state
        .setIn([EVENT_DETAILS_KEY, 'error'], payload.error)
        .setIn([EVENT_DETAILS_KEY, 'processing'], false)
    case SET_EVENT_TRACKS_PROCESSING:
      return state.setIn([EVENT_TRACKS_KEY, 'processing'], payload.processing)
    case SET_EVENT_TRACKS_DATA:
      return state
        .setIn([EVENT_TRACKS_KEY, 'data'], fromJS(payload.data))
        .setIn([EVENT_TRACKS_KEY, 'processing'], false)
    case SET_EVENT_TRACKS_ERROR:
      return state
        .setIn([EVENT_TRACKS_KEY, 'error'], payload.error)
        .setIn([EVENT_TRACKS_KEY, 'processing'], false)
    case SET_EVENT_TRANSLATION_PROCESSING:
      return state.setIn([EVENT_TRANSLATION_KEY, 'processing'], payload.processing)
    case SET_EVENT_TRANSLATION_DATA:
      return state
        .setIn([EVENT_TRANSLATION_KEY, 'data'], fromJS(payload.data))
        .setIn([EVENT_TRANSLATION_KEY, 'processing'], false)
    case SET_EVENT_TRANSLATION_ERROR:
      return state
        .setIn([EVENT_TRANSLATION_KEY, 'error'], payload.error)
        .setIn([EVENT_TRANSLATION_KEY, 'processing'], false)
    case SET_UPDATE_EVENT_TRANSLATION_PROCESSING:
      return state
        .setIn([UPDATE_EVENT_TRANSLATION_KEY, payload.eventId, 'processing'], payload.processing)
        .deleteIn([UPDATE_EVENT_TRANSLATION_KEY, payload.eventId, 'success'])
        .deleteIn([UPDATE_EVENT_TRANSLATION_KEY, payload.eventId, 'error'])
    case SET_UPDATE_EVENT_TRANSLATION_SUCCESS:
      return state
        .setIn([UPDATE_EVENT_TRANSLATION_KEY, payload.eventId, 'success'], true)
        .setIn([UPDATE_EVENT_TRANSLATION_KEY, payload.eventId, 'processing'], false)
    case SET_UPDATE_EVENT_TRANSLATION_ERROR:
      return state
        .setIn([UPDATE_EVENT_TRANSLATION_KEY, payload.eventId, 'error'], payload.error)
        .setIn([UPDATE_EVENT_TRANSLATION_KEY, payload.eventId, 'processing'], false)
    case SET_DELETE_EVENT_TRANSLATION_PROCESSING:
      return state
        .setIn(
          [DELETE_EVENT_TRANSLATION_KEY, payload.eventId, payload.language, 'processing'],
          payload.processing,
        )
        .deleteIn([DELETE_EVENT_TRANSLATION_KEY, payload.eventId, payload.language, 'success'])
        .deleteIn([DELETE_EVENT_TRANSLATION_KEY, payload.eventId, payload.language, 'error'])
    case SET_DELETE_EVENT_TRANSLATION_SUCCESS:
      return state
        .setIn([DELETE_EVENT_TRANSLATION_KEY, payload.eventId, payload.language, 'success'], true)
        .setIn(
          [DELETE_EVENT_TRANSLATION_KEY, payload.eventId, payload.language, 'processing'],
          false,
        )
    case SET_DELETE_EVENT_TRANSLATION_ERROR:
      return state
        .setIn(
          [DELETE_EVENT_TRANSLATION_KEY, payload.eventId, payload.language, 'error'],
          payload.error,
        )
        .setIn(
          [DELETE_EVENT_TRANSLATION_KEY, payload.eventId, payload.language, 'processing'],
          false,
        )
    case SET_DELETE_SPOTLIGHT_TRANSLATION_PROCESSING:
      return state
        .setIn(
          [DELETE_SPOTLIGHT_TRANSLATION_KEY, payload.eventId, payload.language, 'processing'],
          payload.processing,
        )
        .deleteIn([DELETE_SPOTLIGHT_TRANSLATION_KEY, payload.eventId, payload.language, 'success'])
        .deleteIn([DELETE_SPOTLIGHT_TRANSLATION_KEY, payload.eventId, payload.language, 'error'])
    case SET_DELETE_SPOTLIGHT_TRANSLATION_SUCCESS:
      return state
        .setIn(
          [DELETE_SPOTLIGHT_TRANSLATION_KEY, payload.eventId, payload.language, 'success'],
          true,
        )
        .setIn(
          [DELETE_SPOTLIGHT_TRANSLATION_KEY, payload.eventId, payload.language, 'processing'],
          false,
        )
    case SET_DELETE_SPOTLIGHT_TRANSLATION_ERROR:
      return state
        .setIn(
          [DELETE_SPOTLIGHT_TRANSLATION_KEY, payload.eventId, payload.language, 'error'],
          payload.error,
        )
        .setIn(
          [DELETE_SPOTLIGHT_TRANSLATION_KEY, payload.eventId, payload.language, 'processing'],
          false,
        )
    case SET_TRACK_DATA_PROCESSING:
      return state.setIn([TRACK_KEY, payload.trackId, 'processing'], payload.processing)
    case SET_TRACK_DATA:
      return state
        .setIn([TRACK_KEY, 'data'], fromJS(payload.data.track))
        .setIn([TRACK_KEY, 'processing'], false)
    case SET_TRACK_DATA_ERROR:
      return state
        .setIn([TRACK_KEY, payload.trackId, 'error'], payload.error)
        .setIn([TRACK_KEY, payload.trackId, 'processing'], false)
    case SET_CHAT_BLOCKED_USERS_LIST_PROCESSING:
      return state.setIn(
        [CHAT_BLOCKED_USERS_KEY, payload.channel, 'processing'],
        payload.processing,
      )
    case SET_CHAT_BLOCKED_USERS_LIST:
      return state
        .setIn([CHAT_BLOCKED_USERS_KEY, payload.channel, 'data'], fromJS(payload.data))
        .setIn([CHAT_BLOCKED_USERS_KEY, payload.channel, 'processing'], false)
    case SET_CHAT_BLOCKED_USERS_LIST_ERROR:
      return state
        .setIn([CHAT_BLOCKED_USERS_KEY, payload.channel, 'error'], payload.error)
        .setIn([CHAT_BLOCKED_USERS_KEY, payload.channel, 'processing'], false)
    case SET_EVENT_SCHEDULE_DATA_PROCESSING:
      return state.setIn([EVENT_SCHEDULE_KEY, 'processing'], payload.processing)
    case SET_EVENT_SCHEDULE_DATA:
      return state
        .setIn([EVENT_SCHEDULE_KEY, 'data'], fromJS(payload.data))
        .setIn([EVENT_SCHEDULE_KEY, 'processing'], false)
    case SET_EVENT_SCHEDULE_DATA_ERROR:
      return state
        .setIn([EVENT_SCHEDULE_KEY, 'error'], payload.error)
        .setIn([EVENT_SCHEDULE_KEY, 'processing'], false)
    // eslint-disable-next-line no-case-declarations
    case SET_LA_SPOTLIGHT_DATA:
      const key = Object.keys(payload)[0] // eslint-disable-line no-case-declarations
      return state
        .setIn([EVENT_SPOTLIGHT_KEY, key], fromJS(payload[key].spotlight))
        .setIn([EVENT_SPOTLIGHT_KEY, 'processing'], false)
    case SET_LA_SPOTLIGHT_PROCESSING:
      return state.setIn([EVENT_SPOTLIGHT_KEY, 'processing'], payload.processing)
    case SET_LA_SPOTLIGHT_ERROR:
      return state
        .setIn([EVENT_SPOTLIGHT_KEY, payload.language, 'error'], payload.error)
        .setIn([EVENT_SPOTLIGHT_KEY, 'processing'], false)
    case UPDATE_LA_SPOTLIGHT:
      return state.mergeDeepIn([EVENT_SPOTLIGHT_KEY, payload.language], payload.body)
    case SET_UPDATE_LA_SPOTLIGHT_PROCESSING:
      return state.setIn([EVENT_SPOTLIGHT_KEY, 'processing'], payload.processing)
    case SET_UPDATE_LA_SPOTLIGHT_SUCCESS:
      return state.setIn([EVENT_SPOTLIGHT_KEY, 'processing'], false)
    case SET_UPDATE_LA_SPOTLIGHT_ERROR:
      return state
        .setIn([EVENT_SPOTLIGHT_KEY, payload.language, 'error'], payload.error)
        .setIn([EVENT_SPOTLIGHT_KEY, 'processing'], false)
    case SET_CREATE_SESSION_PROCESSING:
      return state.setIn([CREATE_SESSION_KEY, 'processing'], payload.processing)
    case SET_CREATE_SESSION_SUCCESS:
      return state
        .setIn([CREATE_SESSION_KEY, 'success'], true)
        .setIn([CREATE_SESSION_KEY, 'processing'], false)
    case SET_CREATE_SESSION_ERROR:
      return state
        .setIn([CREATE_SESSION_KEY, 'error'], payload.error)
        .setIn([CREATE_SESSION_KEY, 'processing'], false)
    case SET_UPDATE_SESSION_PROCESSING:
      return state.setIn([UPDATE_SESSION_KEY, 'processing'], payload.processing)
    case SET_UPDATE_SESSION_SUCCESS:
      return state
        .setIn([UPDATE_SESSION_KEY, 'success'], true)
        .setIn([UPDATE_SESSION_KEY, 'processing'], false)
    case SET_UPDATE_SESSION_ERROR:
      return state
        .setIn([UPDATE_SESSION_KEY, 'error'], payload.error)
        .setIn([UPDATE_SESSION_KEY, 'processing'], false)
    case SET_UPDATE_SESSION_TRANSLATION_PROCESSING:
      return state.setIn([UPDATE_SESSION_TRANSLATION_KEY, 'processing'], payload.processing)
    case SET_UPDATE_SESSION_TRANSLATION_SUCCESS:
      return state
        .setIn([UPDATE_SESSION_TRANSLATION_KEY, 'success'], true)
        .setIn([UPDATE_SESSION_TRANSLATION_KEY, 'processing'], false)
    case SET_UPDATE_SESSION_TRANSLATION_ERROR:
      return state
        .setIn([UPDATE_SESSION_TRANSLATION_KEY, 'error'], payload.error)
        .setIn([UPDATE_SESSION_TRANSLATION_KEY, 'processing'], false)
    case SET_CREATE_SPEAKER_PROCESSING:
      return state.setIn([CREATE_SPEAKER_KEY, 'processing'], payload.processing)
    case SET_CREATE_SPEAKER_SUCCESS:
      return state
        .setIn([CREATE_SPEAKER_KEY, 'data'], fromJS(payload))
        .setIn([CREATE_SPEAKER_KEY, 'success'], true)
        .setIn([CREATE_SPEAKER_KEY, 'processing'], false)
    case SET_CREATE_SPEAKER_ERROR:
      return state
        .setIn([CREATE_SPEAKER_KEY, 'error'], payload.error)
        .setIn([CREATE_SPEAKER_KEY, 'processing'], false)
    case SET_UPDATE_SPEAKER_PROCESSING:
      return state.setIn([UPDATE_SPEAKER_KEY, 'processing'], payload.processing)
    case SET_UPDATE_SPEAKER_SUCCESS:
      return state
        .setIn([UPDATE_SPEAKER_KEY, 'success'], true)
        .setIn([UPDATE_SPEAKER_KEY, 'processing'], false)
    case SET_UPDATE_SPEAKER_ERROR:
      return state
        .setIn([UPDATE_SPEAKER_KEY, 'error'], payload.error)
        .setIn([UPDATE_SPEAKER_KEY, 'processing'], false)
    case SET_UPDATE_SPEAKER_BIO_PROCESSING:
      return state
        .setIn([UPDATE_SPEAKER_BIO_KEY, 'processing'], payload.processing)
        .deleteIn([UPDATE_SPEAKER_BIO_KEY, 'error'])
    case SET_UPDATE_SPEAKER_BIO_SUCCESS:
      return state
        .setIn([UPDATE_SPEAKER_BIO_KEY, 'success'], true)
        .setIn([UPDATE_SPEAKER_BIO_KEY, 'processing'], false)
    case SET_UPDATE_SPEAKER_BIO_ERROR:
      return state
        .setIn([UPDATE_SPEAKER_BIO_KEY, 'error'], payload.error)
        .setIn([UPDATE_SPEAKER_BIO_KEY, 'processing'], false)
    case CLEAR_UPDATE_SPEAKER_BIO_ERROR:
      return state.deleteIn([UPDATE_SPEAKER_BIO_KEY, 'error'])
    case SET_SPEAKER_PROCESSING:
      return state.setIn([SPEAKER_KEY, 'processing'], payload.processing)
    case SET_SPEAKER_DATA:
      return state
        .setIn([SPEAKER_KEY, 'data'], fromJS(payload.data))
        .setIn([SPEAKER_KEY, 'processing'], false)
        .setIn([UPDATE_SPEAKER_BIO_KEY, 'success'], true)
    case SET_SPEAKER_ERROR:
      return state
        .setIn([SPEAKER_KEY, 'error'], payload.error)
        .setIn([SPEAKER_KEY, 'processing'], false)
    case CLEAR_EVENT_CHAT_INFO:
      return state.delete(CHAT_INFO_KEY)
    case SET_EVENT_CHAT_INFO_DATA_PROCESSING:
      return state.setIn([CHAT_INFO_KEY, 'processing'], payload.processing)
    case SET_EVENT_CHAT_INFO_DATA:
      return state
        .setIn([CHAT_INFO_KEY, 'data'], fromJS(payload.data.chatInfo[0]))
        .setIn([CHAT_INFO_KEY, 'processing'], false)
        .deleteIn([[CHAT_INFO_KEY, 'processing']])
        .deleteIn([[CHAT_INFO_KEY, 'error']])
    case SET_EVENT_CHAT_INFO_DATA_ERROR:
      return state
        .setIn([CHAT_INFO_KEY, 'error'], payload.error)
        .setIn([CHAT_INFO_KEY, 'processing'], false)
    case SET_EVENT_CHAT_INFO_DATA_SUCCESS:
      return state
        .setIn([CHAT_INFO_KEY, 'success'], true)
        .setIn([CHAT_INFO_KEY, 'processing'], false)
    case SET_MEDIALIVE_CHANNEL_INFO_DATA:
      return state
        .setIn([MEDIALIVE_KEY, 'channels', payload.channelId, 'data'], fromJS(payload.data))
        .setIn([MEDIALIVE_KEY, 'channels', payload.channelId, 'success'], true)
        .setIn([MEDIALIVE_KEY, 'channels', payload.channelId, 'processing'], false)
    case SET_MEDIALIVE_CHANNEL_INFO_DATA_PROCESSING:
      return state
        .deleteIn([MEDIALIVE_KEY, 'channels', payload.channelId, 'processing'])
        .deleteIn([MEDIALIVE_KEY, 'channels', payload.channelId, 'error'])
        .setIn([MEDIALIVE_KEY, 'channels', payload.channelId, 'processing'], payload.processing)
    case SET_MEDIALIVE_CHANNEL_INFO_DATA_ERROR:
      return state
        .setIn([MEDIALIVE_KEY, 'channels', payload.channelId, 'error'], payload.error)
        .setIn([MEDIALIVE_KEY, 'channels', payload.channelId, 'processing'], false)
    case CLEAR_MEDIALIVE_CHANNEL_INFO:
      return state.delete(MEDIALIVE_KEY)
    case SET_CREATE_EVENT_CHAT_PROCESSING:
      return state
        .setIn([CHAT_INFO_KEY, 'create', 'processing'], payload.processing)
        .deleteIn([CHAT_INFO_KEY, 'create', 'success'])
        .deleteIn([CHAT_INFO_KEY, 'create', 'error'])
    case SET_CREATE_EVENT_CHAT_ERROR:
      return state
        .setIn([CHAT_INFO_KEY, 'create', 'error'], payload.error)
        .setIn([CHAT_INFO_KEY, 'create', 'processing'], false)
    case SET_CREATE_EVENT_CHAT_SUCCESS:
      return state
        .setIn([CHAT_INFO_KEY, 'create', 'success'], true)
        .setIn([CHAT_INFO_KEY, 'create', 'processing'], false)
    case SET_STREAM_START_PROCESSING:
      return state
        .setIn([START_STREAM_KEY, 'processing'], payload.processing)
        .deleteIn([START_STREAM_KEY, 'success'])
        .deleteIn([START_STREAM_KEY, 'error'])
    case SET_STREAM_START_ERROR:
      return state
        .setIn([START_STREAM_KEY, 'error'], payload.error)
        .setIn([START_STREAM_KEY, 'processing'], false)
    case SET_STREAM_START_SUCCESS:
      return state
        .setIn([START_STREAM_KEY, 'success'], true)
        .setIn([START_STREAM_KEY, 'processing'], false)
    case SET_STREAM_STOP_PROCESSING:
      return state
        .setIn([STOP_STREAM_KEY, 'processing'], payload.processing)
        .deleteIn([STOP_STREAM_KEY, 'success'])
        .deleteIn([STOP_STREAM_KEY, 'error'])
    case SET_STREAM_STOP_ERROR:
      return state
        .setIn([STOP_STREAM_KEY, 'error'], payload.error)
        .setIn([STOP_STREAM_KEY, 'processing'], false)
    case SET_STREAM_STOP_SUCCESS:
      return state
        .setIn([STOP_STREAM_KEY, 'success'], true)
        .setIn([STOP_STREAM_KEY, 'processing'], false)
    case CLEAR_MEDIALIVE_METRICS_DATA:
      return state.delete(MEDIALIVE_METRICS_KEY)
    case SET_MEDIALIVE_METRICS:
      return state
        .setIn(
          [MEDIALIVE_METRICS_KEY, payload.id, 'pipeline', payload.pipeline, payload.name],
          fromJS(payload.data),
        )
        .setIn(
          [
            MEDIALIVE_METRICS_KEY,
            payload.id,
            'pipeline',
            payload.pipeline,
            payload.name,
            'processing',
          ],
          false,
        )
    case SET_MEDIALIVE_METRICS_PROCESSING:
      return state.setIn(
        [
          MEDIALIVE_METRICS_KEY,
          payload.id,
          'pipeline',
          payload.pipeline,
          payload.name,
          'processing',
        ],
        payload.processing,
      )
    case SET_MEDIALIVE_METRICS_ERROR:
      return state
        .setIn(
          [MEDIALIVE_METRICS_KEY, payload.id, 'pipeline', payload.pipeline, payload.name, 'error'],
          payload.error,
        )
        .setIn(
          [
            MEDIALIVE_METRICS_KEY,
            payload.id,
            'pipeline',
            payload.pipeline,
            payload.name,
            'processing',
          ],
          false,
        )
    case DELETE_SESSION_PROCESSING:
      return state.setIn([DELETE_SESSION_KEY, 'processing'], payload.processing)
    case DELETE_SESSION_SUCCESS:
      return state
        .setIn([DELETE_SESSION_KEY, 'success'], true)
        .setIn([DELETE_SESSION_KEY, 'processing'], false)
    case DELETE_SESSION_ERROR:
      return state
        .setIn([DELETE_SESSION_KEY, 'error'], payload.error)
        .setIn([DELETE_SESSION_KEY, 'processing'], false)
    case DELETE_EVENT_PROCESSING:
      return state
        .setIn([DELETE_EVENT_KEY, 'processing'], payload.processing)
        .deleteIn([DELETE_EVENT_KEY, 'success'], true)
        .deleteIn([DELETE_EVENT_KEY, 'error'], true)
    case DELETE_EVENT_SUCCESS:
      return state
        .setIn([DELETE_EVENT_KEY, 'success'], true)
        .setIn([DELETE_EVENT_KEY, 'processing'], false)
    case DELETE_EVENT_ERROR:
      return state
        .setIn([DELETE_EVENT_KEY, 'error'], payload.error)
        .setIn([DELETE_EVENT_KEY, 'processing'], false)
    case SET_USER_EMAIL_PROCESSING:
      return state
        .setIn([USER_EMAIL_KEY, 'processing'], payload.processing)
        .deleteIn([USER_EMAIL_KEY, 'uid'])
        .deleteIn([USER_EMAIL_KEY, 'error'])
        .deleteIn([USER_EMAIL_KEY, 'email'])
    case SET_USER_EMAIL:
      return state
        .setIn([USER_EMAIL_KEY, 'uid'], fromJS(payload.uid))
        .setIn([USER_EMAIL_KEY, 'email'], fromJS(payload.data.email))
        .setIn([USER_EMAIL_KEY, 'processing'], false)
    case SET_USER_EMAIL_ERROR:
      return state
        .setIn([USER_EMAIL_KEY, 'error'], payload.error)
        .setIn([USER_EMAIL_KEY, 'processing'], false)
    case GET_UIDS_FROM_YOUBORA_PROCESSING:
      return state
        .setIn([YOUBORA_UIDS_KEY, 'processing'], payload.processing)
        .deleteIn([YOUBORA_UIDS_KEY, 'data'])
        .deleteIn([YOUBORA_UIDS_KEY, 'error'])
        .deleteIn([YOUBORA_UIDS_KEY, 'email'])
        .deleteIn([YOUBORA_UIDS_KEY, 'requestCurl'])
        .deleteIn([YOUBORA_UIDS_KEY, 'requestDates'])
    case SET_UIDS_FROM_YOUBORA:
      return state
        .setIn([YOUBORA_UIDS_KEY, 'data'], fromJS(payload.data))
        .setIn([YOUBORA_UIDS_KEY, 'processing'], false)
        .setIn([YOUBORA_UIDS_KEY, 'requestCurl'], payload.requestCurl ?? null)
        .setIn(
          [YOUBORA_UIDS_KEY, 'requestDates'],
          payload.requestDates ? fromJS(payload.requestDates) : null,
        )
    case GET_UIDS_FROM_YOUBORA_ERROR:
      return state
        .setIn([YOUBORA_UIDS_KEY, 'error'], payload.error)
        .setIn([YOUBORA_UIDS_KEY, 'processing'], false)
    case CLEAR_UIDS_FROM_YOUBORA:
      return state
        .deleteIn([YOUBORA_UIDS_KEY, 'data'])
        .deleteIn([YOUBORA_UIDS_KEY, 'requestCurl'])
        .deleteIn([YOUBORA_UIDS_KEY, 'requestDates'])
    default:
      return state
  }
}
